import styled from 'styled-components'
import { space, fontSize, width, color, fontWeight, borderColor, borderWidth } from 'styled-system'
import { lineHeight, whiteSpace, borderStyle, textTransform } from './css'

const Span = styled.span`
  ${space} ${whiteSpace} ${lineHeight} ${width} ${color} ${fontWeight} ${fontSize} ${textTransform} ${borderColor} ${borderWidth} ${borderStyle};
`

export default Span
